import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { ValueToColor } from '@core/interfaces/bpc-display-config';
import { SelectOption } from '@shared/interfaces/config';
import { CenterSetting } from '@core/interfaces/center-setting';
import { CenterSettingsFilter } from '@shared/interfaces/config';
import { get } from 'lodash';
import moment from 'moment/moment';
@Component({
  name: 'bpc-select',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Select extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;

  @Prop(Array) readonly options: SelectOption[];

  @Prop(Array) readonly valueToColor: ValueToColor[];

  @Prop([String, Number, Boolean]) readonly initialValue: string | number | boolean;

  get model(): string | number | boolean {
    return this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get filteredOptions(): SelectOption[] {
    return this.options
      .filter(option => {
        if (option.module) {
          return this.checkModulePermissions(option.module);
        }
        return true;
      })
      .filter(option => {
        if (option.centerSettings) {
          return this.checkCenterSettings(option.centerSettings);
        }
        return true;
      });
  }

  checkModulePermissions(mod: string): boolean {
    const hasModuleActivated = this.$modulesService.hasModuleActivated(mod);
    if (hasModuleActivated) {
      return true;
    }

    return false;
  }

  checkCenterSettings(centerSettings: CenterSettingsFilter): boolean {
    const fieldPath = get(centerSettings, 'fieldPath', null);
    const operator = get(centerSettings, 'operator', null);
    const value = get(centerSettings, 'value', null);
    const centerSettingValue = get(this.centerSetting, fieldPath, null);

    return this.compare(operator, value, centerSettingValue);
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get selectClass(): string {
    const color = this.valueToColor?.find(item => item.value === this.model)?.color;
    return color ? `${color}` : '';
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  compare(operator, currentValue, targetValue) {
    switch (operator) {
      case '=':
        return currentValue == targetValue;
      case '!=':
        return currentValue != targetValue;
      case '>':
        return currentValue > targetValue;
      case '<':
        return currentValue < targetValue;
      case '>=':
        return currentValue >= targetValue;
      case '<=':
        return currentValue <= targetValue;
      case 'in':
        return targetValue.indexOf(currentValue) > -1;
      default:
        return false;
    }
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event?.action === 'setMultipleFromBookingForm') {
      this.model = val?.id ? 1 : 0;
    }
  }
}
